import { Tag, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { conversionUtcDate } from '../../utils/comm';

export function AutoRenewStatus({ value }) {
    if (value === true || value === 1 || value === 'true' || value === '1') return <Tag color="green">On</Tag>;
    if (value === false || value === 0 || value === 'false' || value === '0') return <Tag>Off</Tag>;
    return <span>—</span>;
}

export function RenewalUpdatedAt({ value }) {
    if (!value || !dayjs(value).isValid()) return <span>—</span>;
    return (
        <Tooltip title="Last auto-renewal change, shown in your local time. Checks with no change keep this time.">
            <span style={{ whiteSpace: 'nowrap' }}>{conversionUtcDate(value)}</span>
        </Tooltip>
    );
}
